import React from 'react'
import { ClickAwayListener, TableCell, containsInvisibleInput, makeStyles } from '@cicero/ui'
import { IEditorCell } from './types'

export const EditableCell = <T extends any>({
  type,
  editing,
  setEditing,
  value,
  setValue,
  colSpan,
}:{
  type: IEditorCell<T>
  value: T
  setValue: (s: T) => void
  editing: boolean
  setEditing: (editing: boolean) => void
  colSpan?: number
}) => {
  const { cell } = styles()

  return (
    <ClickAwayListener onClickAway={() => editing && setEditing(false)}>
      <TableCell
        colSpan={colSpan}
        className={cell}
        onClick={() => type.editOn === 'singleclick' && !editing && setEditing(true)}
        onDoubleClick={() => setEditing(true)}
      >
        { editing ? <type.editableRenderer value={value} setValue={setValue} onBlur={() => setEditing(false)} /> : <type.renderer value={value} /> }
      </TableCell>
    </ClickAwayListener>
  )
}

const styles = makeStyles({
  cell: {
    minHeight: 22,
    padding: 0,
    transition: 'all ease-in-out .5s',
    ...containsInvisibleInput,

    '& > input': {
      padding: 0,
    },

    '& > td': {
      padding: 0,
    },

    '& > *': {
      width: '100%',
    },

    '&:hover': {
      background: '#f8f9fa',
    },
  },
  cellEdit: {
    // border: '2px solid blue',
    padding: 0,
  },
  cellContents: {
    // padding: '0 6px',
    width: '100%',
    '& input': {
      padding: 16,
    },
  },
})
